(function () {
  angular.module('7Shop.Core')
    .directive('isDesktop', function isDesktop(Touch) {
      return {
        restrict: 'A',
        link: function (scope, elem) {
          // Type of device can be passed through bindings if needed (ios, android, tablet, mobile, etc)
          if (Touch.isTouch('touch')) {
            elem.remove();
          }
        }
      };
    });
})();
